import React, { useState, useEffect, useMemo } from 'react';
import { confirmable, createConfirmation } from 'react-confirm';

import LoadMask from 'components/LoadMask';
import BasicControlGroup from 'components/BasicControlGroup';
import BasicButton from 'components/BasicButton';
import Popup from 'components/Popup';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import CommunicationMessageDialogBody from 'scenes/Dialog/components/CommunicationMessageDialog/components/CommunicationMessageDialogBody';

import UxHelpers from 'helpers/ux-helpers';
import { ENDPOINT } from 'constants/endpoints';
import { useApi } from 'hooks/useApi';

const CommunicationMessageDialog = props => {
  const { id, show, proceed, cancel, dismiss } = props;

  const api = useApi();

  const [state, setState] = useState({ init: false });

  useEffect(() => {
    api.get(
      ENDPOINT.ENTITY.COMMUNICATION_MESSAGE,
      { id },
      {
        handleError: response => {
          dismiss();
          ResponseErrorDialog({ response });
        },
        handleSuccess: response => setState({ init: true, ...response }),
      }
    );
  }, []);

  const proceedHandler = () => {
    proceed();
    UxHelpers.overflowLock('unlock');
  };

  const bodyRender = useMemo(
    () => (
      <div
        style={{ position: 'relative', minWidth: '300px', minHeight: '80px' }}
      >
        {state.init ? (
          <CommunicationMessageDialogBody message={state} />
        ) : (
          <LoadMask relative />
        )}
      </div>
    ),
    [state]
  );

  const buttons = useMemo(
    () =>
      state.init ? (
        <BasicControlGroup
          groupStyles={{ marginRight: 'auto', marginLeft: 'auto' }}
        >
          <BasicButton
            controlFunc={proceedHandler}
            btnWidth={200}
            btnHeight={35}
            btnFontWeight={500}
            btnFontSize="0.8571rem"
            btnArrow={false}
            btnTextColor="#27282d"
            btnText="Close"
          />
        </BasicControlGroup>
      ) : null,
    [state]
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
          cancel,
        }}
        hasCloseButton={true}
        buttonsRender={buttons}
        bodyRender={bodyRender}
        popupStyles={{
          padding: '30px',
        }}
      />
    )
  );
};

export default createConfirmation(confirmable(CommunicationMessageDialog));
